var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ChecklistOutlinedIcon from "@mui/icons-material/ChecklistOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import { Chip, Stack } from "@mui/material";
import { Colors } from "../../util/theme";
export var FilterInfrationsEnum;
(function (FilterInfrationsEnum) {
    FilterInfrationsEnum["TODAS"] = "Todas";
    FilterInfrationsEnum["EM_ABERTO"] = "Em Aberto";
    FilterInfrationsEnum["CANCELADAS"] = "Canceladas";
    FilterInfrationsEnum["PAGAS"] = "Pagas";
    FilterInfrationsEnum["EM_ATRASO"] = "Em Atraso";
})(FilterInfrationsEnum || (FilterInfrationsEnum = {}));
export var ChipFilters = function (_a) {
    var newFilter = _a.newFilter;
    var _b = useState(FilterInfrationsEnum.TODAS), valueSelected = _b[0], setValueSelected = _b[1];
    var changeValueSelected = function (value) {
        if (value === valueSelected) {
            setValueSelected(FilterInfrationsEnum.TODAS);
            newFilter(FilterInfrationsEnum.TODAS);
        }
        else {
            setValueSelected(value);
            newFilter(value);
        }
    };
    var verifyColor = function (value) {
        if (value === valueSelected) {
            return Colors.AZUL_GOV;
        }
        else {
            return "#aabde6";
        }
    };
    return (_jsxs(Stack, __assign({ direction: "row", gap: "1rem", mb: "1rem" }, { children: [_jsx(Chip, { sx: {
                    backgroundColor: verifyColor(FilterInfrationsEnum.TODAS),
                    color: "white",
                    "&:hover": { backgroundColor: Colors.AZUL_GOV },
                }, icon: _jsx(ChecklistOutlinedIcon, { color: "inherit" }), label: "Todas", onClick: function () { return changeValueSelected(FilterInfrationsEnum.TODAS); } }), _jsx(Chip, { sx: {
                    backgroundColor: verifyColor(FilterInfrationsEnum.EM_ABERTO),
                    color: "white",
                    "&:hover": { backgroundColor: Colors.AZUL_GOV },
                }, icon: _jsx(InfoOutlinedIcon, { color: "inherit" }), label: "Em Aberto", onClick: function () { return changeValueSelected(FilterInfrationsEnum.EM_ABERTO); } }), _jsx(Chip, { sx: {
                    backgroundColor: verifyColor(FilterInfrationsEnum.CANCELADAS),
                    color: "white",
                    "&:hover": { backgroundColor: Colors.AZUL_GOV },
                }, icon: _jsx(WarningAmberOutlinedIcon, { color: "inherit" }), label: "Canceladas", onClick: function () { return changeValueSelected(FilterInfrationsEnum.CANCELADAS); } }), _jsx(Chip, { sx: {
                    backgroundColor: verifyColor(FilterInfrationsEnum.PAGAS),
                    color: "white",
                    "&:hover": { backgroundColor: Colors.AZUL_GOV },
                }, icon: _jsx(CheckCircleOutlineOutlinedIcon, { color: "inherit" }), label: "Pagas", onClick: function () { return changeValueSelected(FilterInfrationsEnum.PAGAS); } }), _jsx(Chip, { sx: {
                    backgroundColor: verifyColor(FilterInfrationsEnum.EM_ATRASO),
                    color: "white",
                    "&:hover": { backgroundColor: Colors.AZUL_GOV },
                }, icon: _jsx(ErrorOutlineOutlinedIcon, { color: "inherit" }), label: "Em Atraso", onClick: function () { return changeValueSelected(FilterInfrationsEnum.EM_ATRASO); } })] })));
};
